import { Component, ChangeDetectionStrategy, inject } from '@angular/core';
import { NonNullableFormBuilder, Validators } from '@angular/forms';
import { ContactFormComponent } from '../../../shared/components/contact-form/contact-form.component';

@Component({
    selector: 'app-meet-form',
    templateUrl: './meet-form.component.html',
    styleUrls: ['./meet-form.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [ContactFormComponent],
})
export class MeetFormComponent {
    private formBuilder = inject(NonNullableFormBuilder);

    form = this.formBuilder.group({
        company: ['', Validators.required],
        nip: ['', Validators.required],
        phone: ['', Validators.required],
        address: ['', Validators.required],
    });

    get company() {
        return this.form.get('company');
    }

    get nip() {
        return this.form.get('nip');
    }

    get phone() {
        return this.form.get('phone');
    }

    get address() {
        return this.form.get('address');
    }

    onSubmit(): void {
        if (this.form.valid) {
            // submit
        } else {
            this.form.markAllAsTouched();
        }
    }
}
